import { useState } from 'react'
import toast from 'react-hot-toast'
import './ShareButton.css'

const ShareButton = ({ event }) => {
  const [showShareOptions, setShowShareOptions] = useState(false)

  const shareUrl = window.location.href

  const shareOptions = [
    {
      name: 'Copy Link',
      icon: 'fas fa-link',
      action: async () => {
        try {
          await navigator.clipboard.writeText(shareUrl)
          toast.success('Link copied to clipboard!')
        } catch (err) {
          console.error('Failed to copy:', err)
          toast.error('Failed to copy link to clipboard')
        }
      }
    },
    {
      name: 'Facebook',
      icon: 'fab fa-facebook-f',
      action: () => {
        const fbUrl = `https://www.facebook.com/sharer.php?u=${encodeURIComponent(shareUrl)}`
        window.open(
          fbUrl,
          '_blank',
          'width=600,height=400'
        )
      }
    },
    {
      name: 'Twitter',
      icon: 'fab fa-twitter',
      action: () => {
        window.open(
          `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(event.title)}`,
          '_blank'
        )
      }
    },
    {
      name: 'LinkedIn',
      icon: 'fab fa-linkedin-in',
      action: () => {
        const linkedInUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(event.title || '')}&summary=${encodeURIComponent(event.subtitle || event.overview || '')}`
        window.open(
          linkedInUrl,
          '_blank',
          'width=600,height=400'
        )
      }
    },
    {
      name: 'WhatsApp',
      icon: 'fab fa-whatsapp',
      action: () => {
        window.open(
          `https://api.whatsapp.com/send?text=${encodeURIComponent(event.title + ' ' + shareUrl)}`,
          '_blank'
        )
      }
    }
  ]

  if (showShareOptions) {
    return (
      <div className="share-items">
        {shareOptions.map((option, idx) => {
          // Map each option to its specific class for better styling
          const optionClass = option.name === 'Facebook' ? 'share-option share-option-facebook' :
                             option.name === 'Twitter' ? 'share-option share-option-twitter' :
                             option.name === 'LinkedIn' ? 'share-option share-option-linkedin' :
                             option.name === 'WhatsApp' ? 'share-option share-option-whatsapp' :
                             'share-option share-option-default'
          
          return (
            <div
              key={idx}
              className={optionClass}
              onClick={option.action}
              title={option.name}
            >
              <i className={option.icon}></i>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <button
      className="share-btn"
      onClick={() => setShowShareOptions(true)}
    >
      <i className="fas fa-share-alt"></i>
      <span>Share</span>
    </button>
  )
}

export default ShareButton

